import { createContext, useContext, useEffect, useState } from "react";
import { Navigate } from "react-router-dom";
import { api, setToken, clearToken, getToken, formatApiError } from "../lib/api";

const AdminAuthContext = createContext(null);

export const AdminAuthProvider = ({ children }) => {
  // user: null = loading, false = not authenticated, object = authenticated
  const [user, setUser] = useState(getToken() ? null : false);

  useEffect(() => {
    let active = true;
    if (!getToken()) {
      setUser(false);
      return;
    }
    api
      .get("/auth/me")
      .then(({ data }) => active && setUser(data))
      .catch(() => {
        clearToken();
        if (active) setUser(false);
      });
    return () => {
      active = false;
    };
  }, []);

  const login = async (email, password) => {
    try {
      const { data } = await api.post("/auth/login", { email, password });
      setToken(data.token);
      setUser(data.user);
      return { ok: true };
    } catch (e) {
      return { ok: false, error: formatApiError(e.response?.data?.detail) || e.message };
    }
  };

  const logout = () => {
    clearToken();
    setUser(false);
  };

  return (
    <AdminAuthContext.Provider value={{ user, login, logout }}>
      {children}
    </AdminAuthContext.Provider>
  );
};

export const useAdminAuth = () => useContext(AdminAuthContext);

export const ProtectedRoute = ({ children }) => {
  const { user } = useAdminAuth();
  if (user === null) {
    return (
      <div className="flex min-h-screen items-center justify-center bg-pblv-bg text-pblv-inksoft">
        Chargement…
      </div>
    );
  }
  if (!user) return <Navigate to="/admin/login" replace />;
  return children;
};
